import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    width: window.innerWidth,
    subscribeDialog: false,
    options: {}
  },
  getters: {
    isMobile (state) {
      return state.width <= 768
    }
  },
  mutations: {
    TOGGLE (state, {key, val}) {
      state[key] = val
    }
  },
  actions: {
    toggle () {

    }
  }
})
